import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ModulesContext } from "../../App";
import { HIDE, REDIRECT } from "../../Constants/protectionBehaviors.js";
import Loader from "../Simple/Loader.js";

const Protect = ({ module, behavior = HIDE, children }) => {
    const modulesContext = useContext(ModulesContext);
    
    if (modulesContext.loading) {
        return <div className="row justify-content-center align-items-center">
                <div className="col-auto mt-5">
                Loading <Loader />
                </div>
            </div>;
    }
    
    if (!modulesContext.modules.includes(module)) {
        switch (behavior) {
            case HIDE:
                return null;
            case REDIRECT:
                return <Navigate to="/errors/unauthorized" />
            default:
                console.log("No behavior given to Protect component");
                return null;
        }
    } else {
        return children || <Outlet />;
    }
}

export default Protect;
